import * as React from 'react';
import AuthContext from 'Context/AuthContext';
import IfNotTrueModal from '../IfNotTrueModal';
import { Button, Typography } from 'antd';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { SpacedSpan } from './IfNotLoggedInModal.Styled';

export interface Props extends RouteComponentProps {
  children?: React.ReactNode;
}

export interface State {
  LoggedIn: boolean;
  contextData?: any;
}

export class IfNotLoggedInModalWithoutRouter extends React.Component<Props, State> {
  static contextType = AuthContext;
  context!: React.ContextType<typeof AuthContext>;

  constructor(props: Props) {
    super(props);

    this.state = {
      LoggedIn: false,
    };
  }

  componentDidMount() {
    this.setState({ contextData: this.context.data, LoggedIn: !!this.context.data });
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (this.state.contextData != this.context.data) {
      // person not logged in
      if (!this.context.data) {
        this.setState({ LoggedIn: false, contextData: this.context.data });
      } else {
        this.setState({ LoggedIn: true, contextData: this.context.data });
      }
    }
  }

  SendToRegister = () => {
    this.props.history.push('/register');
  };

  SendToLogin = () => {
    this.props.history.push('/login');
  };

  actions = [
    <Button onClick={this.SendToLogin}>Log In</Button>,
    <Button type="primary" onClick={this.SendToRegister}>
      Sign Up
    </Button>,
  ];

  render() {
    return (
      <IfNotTrueModal
        cancelText="Close"
        showCancel={true}
        title={<Typography.Title level={3}>Lets Get You Started</Typography.Title>}
        message={
          <SpacedSpan>
            In order to apply you must login. If you do not already have an account you can register
            for one.
          </SpacedSpan>
        }
        condition={this.state.LoggedIn}
        actions={this.actions}>
        {this.props.children}
      </IfNotTrueModal>
    );
  }
}

const IfNotLoggedInModal = withRouter(IfNotLoggedInModalWithoutRouter);

export default IfNotLoggedInModal;
